import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/Marquee";
import { TrustBadges } from "@/components/TrustBadges";
import { Services } from "@/components/Services";
import { About } from "@/components/About";
import { ServiceArea } from "@/components/ServiceArea";
import { Gallery } from "@/components/Gallery";
import { Reviews } from "@/components/Reviews";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";

export default function Home() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <TrustBadges />
        <Services />
        <About />
        <ServiceArea />
        <Gallery />
        <Reviews />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
